import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCDurationForm from "./supervisor-tc-duration/tc-duration-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import { browserHistory } from "react-router";

export default class SupervisorTCDuration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            peopleId: null,
            assignId: null,
            offSysId: null,
            timecardId: null,
            weekEnding: null,
            hideButtonPanel: true,
            buttons: "",
            allowEdit: false,
            errors: []
        };
        this.role = context.getRouteParam(this, "role");
        this.statusCode = null;

        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.onVerify = this.onVerify.bind(this);
    }

    componentDidMount() {
    }

    onVerify() {
        const hasUnapprovedPto = this.refs.durationForm.refs.miscList.hasUnapprovedPto();
        if (hasUnapprovedPto)
            return false;

        context.message({
            show: true,
            type: "loading",
            message: "Processing. Please wait...",
        });

        let self = this;
        const timecardId = this.state.timecardId;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        let submitted = this.statusCode == "saved" ? 0 : 1;
        ajax.api()
            .put(`add-notes/${timecardId}`, { role: self.role, notes: newNotes })
            .then(function (res) {
                const preurl = context.routeUrl(`${self.role}/tc-duration/${timecardId}`);
                const url = context.appRoot();
                ajax.api()
                    .post("prepare-timecard-verification", {
                        timecards: [timecardId],
                        submitted: submitted,
                        mainUrl: preurl,
                        performValidation: true
                    })
                    .then(function (res) {

                        context.message({ show: false });
                        var data = res.data[0];
                        if (data && data.errorMessages && data.errorMessages.length > 0) {
                            const clone = immutable.fromJS(self.state).toJS();
                            clone.errors = [];
                            data.errorMessages.forEach(v => clone.errors.push(v));
                            self.setState(clone);
                        } else {
                            //window.location = context.root() + `/../Common/ApproveTimecard.aspx?v2=1&token=${res.data}&preurl=${preurl}&url=${url}`;
                            browserHistory.push(context.routeUrl(`${self.role}/tc-approval/${submitted}`));
                        }
                    })
                    .catch(function (err) {
                        const clone = immutable.fromJS(self.state).toJS();
                        clone.errors = [];
                        let data = err.response.data;
                        if (data.exceptionMessage.length > 1 || data.message.length > 1) {
                            clone.errors.push(data.exceptionMessage || data.message);
                        } else {
                            for (let k in data.data) {
                                clone.errors.push(data.data[k]);
                            }
                        }
                        context.message({ show: false });
                        self.setState(clone);
                    });
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error when attempting to add notes.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    onLoadTimecardCompleted(tc, errors) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecardId = tc.timecardId;
        clone.offSysId = tc.offsysid;
        clone.assignId = tc.placementId;
        clone.peopleId = tc.peopleId;
        clone.weekEnding = moment(tc.weekEnding).format("MM-DD-YYYY");
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        clone.errors = (errors == null) ? [] : errors;

        this.statusCode = tc.statusCode.toLowerCase();
        clone.allowEdit = (this.statusCode === "saved" || this.statusCode === "submitted");
        this.setState(clone);
    }

    prepareButtonPanel(tc) {
        const result = {
            hideButtonPanel: true,
            buttons: ""
        };
        if (tc) {
            const statusCode = tc.statusCode.toLowerCase();
            if (statusCode === "saved" || statusCode === "submitted" || (statusCode === "approved" && tc.approvedDate == null)) {
                result.hideButtonPanel = false;
                result.buttons = "verify";
            }
        }

        return result;
    }

    render() {
        const tcWeekEnding = moment(this.state.weekEnding).endOf("week");
        const curWeekEnding = moment().endOf("week");

        let hideGrid = tcWeekEnding.isAfter(curWeekEnding);

        let alert = "";

        if (this.state.errors.length > 0) {
            alert = <Alert bsStyle="danger"><ul>
                {
                    this.state.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>;
        }

        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-12 text-center ap-h1">
                            Time Sheet
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <ControlLabel>This timecard is for the week-ending : {this.state.weekEnding}</ControlLabel>
                        </div>
                    </div>

                </div>
                <TCDurationForm timecardId={this.props.params.timecardId} weekEnding={this.state.weekEnding}
                    peopleId={this.state.peopleId} assignId={this.state.assignId} offSysId={this.state.offSysId}
                    allowEdit={this.state.allowEdit}
                    hideGrid={hideGrid}
                    ref="durationForm"
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted}
                    role={this.role} />
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-12">
                            {alert}
                        </div>
                    </div>
                </div>
                <TCButtonPanel buttons={this.state.buttons}
                    hidden={this.state.hideButtonPanel}
                    onVerify={this.onVerify} />
            </div>
        );
    }
}
